import axios, { AxiosResponse } from "axios"

import {
  PredictionModelsListRequest,
  PredictionModelsListResponse,
  PredictionModelStatusRequest,
  PredictionModelStatusResponse,
  PredictionModelArchiveRequest,
  PredictionModelArchiveResponse,
  PredictionModelResetActionsResponse,
  PredictionsListRequest,
  PredictionsListResponse,
  CreateModelRequest,
  CreateModelResponse,
  UpdateModelRequest,
  UpdateModelResponse,
  GetModelResponse,
  PredictionDictionariesResponse,
  PredictionActionsHistoryRequest,
  PredictionActionsHistoryResponse,
  FilterListValuesRequest,
  FilterListValuesResponse,
} from "../../../../pages/purchase-prediction/types"
import { axiosConfigAuth } from "../middleware"
import {
  API_PREDICTION_MODELS_LIST,
  API_PREDICTION_MODELS_CREATE,
  API_PREDICTION_MODELS_GET,
  API_PREDICTION_MODELS_UPDATE,
  API_PREDICTION_MODELS_STATUS,
  API_PREDICTION_MODELS_ARCHIVE,
  API_PREDICTION_MODELS_RESET_ACTIONS,
  API_PREDICTION_MODELS_PREDICTIONS_LIST,
  API_PREDICTION_MODELS_ACTIONS_HISTORY,
  API_PREDICTION_MODELS_DICTIONARIES,
  API_GET_FILTER_LIST,
} from "../urls"

export const predictionModelsApi = {
  fetchModelsList: async (
    params: PredictionModelsListRequest
  ): Promise<AxiosResponse<PredictionModelsListResponse>> => {
    return axios.post(API_PREDICTION_MODELS_LIST, params, axiosConfigAuth())
  },

  updateModelStatus: async (
    modelId: number,
    params: PredictionModelStatusRequest
  ): Promise<AxiosResponse<PredictionModelStatusResponse>> => {
    return axios.patch(
      API_PREDICTION_MODELS_STATUS(modelId),
      params,
      axiosConfigAuth()
    )
  },

  updateModelArchive: async (
    modelId: number,
    params: PredictionModelArchiveRequest
  ): Promise<AxiosResponse<PredictionModelArchiveResponse>> => {
    return axios.patch(
      API_PREDICTION_MODELS_ARCHIVE(modelId),
      params,
      axiosConfigAuth()
    )
  },

  // Очистить журнал выполненных действий: при ближайшем прогнозе они выполнятся заново
  resetModelActions: async (
    modelId: number
  ): Promise<AxiosResponse<PredictionModelResetActionsResponse>> => {
    return axios.patch(
      API_PREDICTION_MODELS_RESET_ACTIONS(modelId),
      {},
      axiosConfigAuth()
    )
  },

  fetchPredictionsList: async (
    params: PredictionsListRequest
  ): Promise<AxiosResponse<PredictionsListResponse>> => {
    return axios.post(
      API_PREDICTION_MODELS_PREDICTIONS_LIST,
      params,
      axiosConfigAuth()
    )
  },

  createModel: async (
    params: CreateModelRequest
  ): Promise<AxiosResponse<CreateModelResponse>> => {
    return axios.post(API_PREDICTION_MODELS_CREATE, params, axiosConfigAuth())
  },

  getModel: async (
    modelId: number
  ): Promise<AxiosResponse<GetModelResponse>> => {
    return axios.get(API_PREDICTION_MODELS_GET(modelId), axiosConfigAuth())
  },

  updateModel: async (
    modelId: number,
    params: UpdateModelRequest
  ): Promise<AxiosResponse<UpdateModelResponse>> => {
    return axios.put(
      API_PREDICTION_MODELS_UPDATE(modelId),
      params,
      axiosConfigAuth()
    )
  },

  getDictionaries: async (
    dictionaries?: string
  ): Promise<AxiosResponse<PredictionDictionariesResponse>> => {
    const url = dictionaries
      ? `${API_PREDICTION_MODELS_DICTIONARIES}?dictionaries=${dictionaries}`
      : API_PREDICTION_MODELS_DICTIONARIES
    return axios.get(url, axiosConfigAuth())
  },

  fetchActionsHistory: async (
    params: PredictionActionsHistoryRequest
  ): Promise<AxiosResponse<PredictionActionsHistoryResponse>> => {
    return axios.post(
      API_PREDICTION_MODELS_ACTIONS_HISTORY,
      params,
      axiosConfigAuth()
    )
  },

  fetchFilterValues: async (
    params: FilterListValuesRequest
  ): Promise<AxiosResponse<FilterListValuesResponse>> => {
    return axios.post(API_GET_FILTER_LIST, params, axiosConfigAuth())
  },
}
